import { useCallback } from 'react';

/**
 * React 19 compatibility hook for React DnD's dragRef and dropRef
 * https://github.com/react-dnd/react-dnd/issues/3670
 */
function useDragDropRef<T extends HTMLElement | null>(
  dragOrDrop: (element: T) => void,
) {
  return useCallback(
    (element: T) => {
      dragOrDrop(element);
    },
    [dragOrDrop],
  );
}

export default useDragDropRef;
